export class BenefitSelection {
    isMultiSelect: boolean;
    showUnavailableColumn: boolean;
    secondaryMode: string;
    totalItems: number;
    totalPages: number;
    pageSize: number;
    items: BenefitSelectionItem[];

    constructor() {
        this.isMultiSelect = false;
        this.showUnavailableColumn = false;
        this.secondaryMode = null;
        this.totalItems = 0;
        this.totalPages = 0;
        this.pageSize = 0;
        this.items = new Array<BenefitSelectionItem>();
    }
}

export class BenefitSelectionItem {
    benefitNumber: number;
    uniqueID: string;
    enrollmentName: string;
    isSelected: boolean;
    isRequired: boolean;
    availableOn: string;
    unavailableOn: string;
    memberBenefitID?: number;

    constructor() {
        this.benefitNumber = 0;
        this.uniqueID = null;
        this.enrollmentName = null;
        this.isSelected = false;
        this.isRequired = false;
        this.availableOn = null;
        this.unavailableOn = null;
        this.memberBenefitID = 0;
    }
}

export class BenefitTermSelection {
    isMultiSelect: boolean;
    totalItems: number;
    items: BenefitSelectionItem[];

    constructor() {
        this.isMultiSelect = false;
        this.totalItems = 0;
        this.items = new Array<BenefitSelectionItem>();
    }
}

export class BenefitSelectionPayload {
    uniqueIDs: string[];
    memberBenefitIDs: string[];
    selectedBenefitName: string;
    selectedBenefitAvailable: string;

    constructor() {
        this.uniqueIDs = new Array<string>();
        this.memberBenefitIDs = new Array<string>();
        this.selectedBenefitName = null;
        this.selectedBenefitAvailable = null;
    }
}

export class AutoEnrollResponse {
    totalItems: number;
    totalPages: number;
    pageSize: number;
    items: BenefitSelectionItem[];

    constructor() {
        this.totalItems = 0;
        this.totalPages = 0;
        this.pageSize = 0;
        this.items = new Array<BenefitSelectionItem>();
    }
}